import styled from 'styled-components';
import { device } from '@/styles/helpers';
import { ScTopGames } from '../TopGames/styled';

export const ScGamesWrapper = styled.div`
  max-width: 480px;
  margin: 0 -32px;

  @media (${device.mobile}) {
    max-width: calc(100vw - 16px);
    margin: 0 -16px;
  }

  ${ScTopGames} {
    .title {
      color: ${({ theme }) => theme.white};
      @media (${device.mobile}) {
        font-size: 22px;
      }
    }

    & .swiper-wrapper {
      margin-left: -45px;

      @media (${device.mobile}) {
        margin-left: 0;
      }
    }
  }
`;
